import { ValidatorInput } from './validation/validation-descriptor.entity';
import { ValidationChecks } from './validation/validation-checks.enum';
import { BeziehungenZuKundeResponse } from '../../generated/api/kreditportalBackendAPI.schemas';
import { Validator } from './validation/validator.util';

export class KundenRelationsModel {

    maklerId = new ValidatorInput(
        'makler',
        '',
        'Vermittlernummer',
        /^\d{9}$/,
        'Bitte geben Sie die Vermittlernummer im Format nnnnnnnnn ein.',
        true,
        ValidationChecks.NOT_EMPTY_CHECK | ValidationChecks.CUSTOM_REGEX_CHECK
    );

    steuerberater = new ValidatorInput(
        'steuerberater',
        '', 'Steuerberaternummer',
        /^023\d{10}$/,
        'Die Steuerberaternummer muss 13-stellig sein und mit 023 beginnen.',
        true,
        ValidationChecks.NOT_EMPTY_CHECK | ValidationChecks.CUSTOM_REGEX_CHECK
    );

    copyData = (beziehungenZuKundeResponse: BeziehungenZuKundeResponse) => {
        if (beziehungenZuKundeResponse.steuerberaterId) {
            this.steuerberater.value = '0' + beziehungenZuKundeResponse.steuerberaterId;
        } else {
            this.steuerberater.value = '';
        }

        if (beziehungenZuKundeResponse.maklerId) {
            this.maklerId.value = (beziehungenZuKundeResponse.maklerId + '').padStart(9, '0');
        } else {
            this.maklerId.value = '';
        }
    };

    validateField(field: ValidatorInput) {
        field.valid = Validator.doValidate(field, 1, []);
    }

}
